angular.module 'zc.projects'

.directive 'zcLabelUserInvitation', ($translate) ->
  restrict: 'E'
  scope:
    user: '='
  template: """
    <span
      class="label label-info"
      ng-if="invited && !accepted && user.valid_invitation">
      #{$translate.instant('projectsSettings.users.labelUserInvitation.inviting')}
    </span>
    <span
      class="label label-warning"
      ng-if="invited && !accepted && !user.valid_invitation">
      #{$translate.instant('projectsSettings.users.labelUserInvitation.expired')}
    </span>
  """
  link: (scope, element, attrs) ->
    scope.invited = !!scope.user.invitation_created_at
    scope.accepted = !!scope.user.invitation_accepted_at



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/users/label_user_invitation.directive.coffee